<template>
  <div>
    <div class="user_module">
      <div class="module_head module_head2">
        <div>当前企业下属用户</div>
        <div class="btn_outer">
          <el-button type="primary" plain @click="toAddus"><i class="cloudicon ci_plus"></i> 增加用户</el-button>
        </div>
      </div>
      <div class="module_tab_cont sb_fav">
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table zebra fc bnone">
            <tr class="text_center">
              <th class="td_bg">用户名</th>
              <th class="td_bg">使用人姓名</th>
              <th class="td_bg">部门</th>
              <th class="td_bg">手机号</th>
              <th class="td_bg">邮箱</th>
              <th class="td_bg" width="160px">操作</th>
            </tr>
            <tr v-for="(item,index) in tablelist" class="text_center">
              <td>{{ item.username }}</td>
              <td>{{ item.user_nickname }}</td>
              <td>{{ item.dept }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.user_email }}</td>
              <td>
                <div class="operate_outer">
                  <span class="btn_able" @click="disableUser(item.id,item.user_status===1?2:1)" v-text="item.user_status===1?'禁用':'启用'"></span>
                  <span class="btn_edi" @click="editUser(item)">编辑</span>
                  <span class="btn_del" @click="delUser(item.id)">删除</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="840px">
      <el-form :model="currentItem" :rules="mode==='add'?rules01:rules02" ref="ruleForm" class="demo-ruleForm">
      <div class="d_content">
        <table border="0" cellspacing="0" cellpadding="0" class="table">
          <tr>
            <td class="td_bg" width="90px">用户名 <span style="color: red;font-weight: bold">*</span></td>
            <td>
              <el-form-item  prop="username">
              <el-input v-model="currentItem.username" maxlength="11" :disabled="mode==='edit'"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="td_bg" width="90px">使用人姓名 <span style="color: red;font-weight: bold">*</span></td>
            <td>
              <el-form-item  prop="user_nickname">
                <el-input v-model="currentItem.user_nickname"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="td_bg">部门</td>
            <td>
              <el-input v-model="currentItem.dept"></el-input>
            </td>
          </tr>
          <tr>
            <td class="td_bg">手机号 <span style="color: red;font-weight: bold">*</span></td>
            <td>
              <el-form-item  prop="mobile">
              <el-input  oninput ="value=value.replace(/[^\d]/g,'')"  v-model="currentItem.mobile"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="td_bg">邮箱</td>
            <td>
              <el-input v-model="currentItem.user_email"></el-input>
            </td>
          </tr>
          <tr>
            <td class="td_bg">权限  <span style="color: red;font-weight: bold">*</span></td>
            <td>
              <el-form-item  prop="checkList">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="1">数据调查</el-checkbox>
                <el-checkbox label="2">申报项目</el-checkbox>
                <el-checkbox label="3">我有诉求</el-checkbox>
                <el-checkbox label="4">企业走访</el-checkbox>
                <el-checkbox label="5">人员登记</el-checkbox>
              </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
        </table>
        注意：
        <div>（1）提交后，用户名不可修改；</div>
        <div>（2）用户名和手机号码不可与已有账号相同。</div>
      </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSubmitAdd">提 交</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  created() {
    this.initList();
  },
  name: 'usermanage',
  inject: ['reload'],
  data() {
    var validateComfirmPwd = (rule, value, callback) => {
      if (this.currentItem.checkList.length==0) {
        callback(new Error('至少勾选一个权限'))
      } else {
        callback()
      }
    }

    return {
      currentItem: {
        id: null,
        checkList: [],
        username: null,
        user_nickname:null,
        dept: null,
        mobile: null,
        user_email: null,
      },
      checkList:[],
      tablelist: [],
      dialogVisible: false,
      currentPage: 1,
      pagesize: 10,
      mode: 'add',
      rules01: {
        username: [
          {type: 'string', required: true,message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 11, message: '长度不能超过11', trigger: 'change' }
        ],
        user_nickname: [
          {type: 'string', required: true, message: '请输入使用人姓名', trigger: 'blur' },
        ],
        mobile:[
          {type: 'string', required: true, message: '请输入用户手机号', trigger: 'blur' },
        ],
        checkList:[
          { validator: validateComfirmPwd, trigger: 'change' }
        ]
      },
      rules02: {
        username: [
          {type: 'string', required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        user_nickname: [
          {type: 'string', required: true, message: '请输入使用人姓名', trigger: 'blur' },
        ],
        mobile:[
          {type: 'string', required: true, message: '请输入用户手机号', trigger: 'blur' },
        ],
        checkList:[
          { validator: validateComfirmPwd, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async onSubmitAdd() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.submitAdd();
        } else {
          setTimeout(()=>{
            var isError = document.getElementsByClassName("is-error");
            var htmlInputElement = isError[0].querySelector('input');
            if(htmlInputElement) htmlInputElement.focus();

            var htmlAreaElement = isError[0].querySelector('textarea');
            if(htmlAreaElement) htmlAreaElement.focus();
          },100);
          // alert('error submit!!');
          return false;
        }
      });
    },
    async submitAdd() {
      let res = null;
      if (this.mode === 'add') {  // 添加
        let data = {
          username: this.currentItem.username,
          user_nickname: this.currentItem.user_nickname,
          dept: this.currentItem.dept,
          mobile: this.currentItem.mobile,
          user_email: this.currentItem.user_email
        };
        data.role_id = this.currentItem.checkList.join(",");
        res = await this.$ajax.post(this.bUrl + 'api/portal/user/addUser', data);
      } else if (this.mode === 'edit' && this.currentItem.id != null) { // 编辑
        let data = {
          id: this.currentItem.id,
          user_nickname: this.currentItem.user_nickname,
          dept: this.currentItem.dept,
          mobile: this.currentItem.mobile,
          user_email: this.currentItem.user_email
        }
        data.role_id = this.currentItem.checkList.join(",");
        res = await this.$ajax.post(this.bUrl + 'api/portal/user/editUser', data);
      }
      if (res !== null && res.data.code === 200) {
        this.$message.success(res.data.msg);
        this.dialogVisible = false;
        this.reload();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    toAddus() {
      this.dialogVisible = true;
      this.currentItem.id = null;
      this.mode = 'add';
      this.currentItem.username = null;
      this.currentItem.user_nickname = null;
      this.currentItem.checkList = [];
      this.currentItem.dept = "";
      this.currentItem.mobile = null;
      this.currentItem.user_email = null;
    },
    close() {
      this.dialogVisible = false;
      this.reload()
    },

    async initList() {
      let res = await this.$ajax.get(this.bUrl + `api/portal/user/userList?page=${this.currentPage}`);
      if(res.data.code!=200){ this.$message.error(res.data.msg); }
      this.tablelist = res.data.data
    },
   async disableUser(id,status) {
     let data={id,status};
      if(status===1){
        await this.$confirm('启用该用户吗?', '启用用户', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'});
        let res = await this.$ajax.post(this.bUrl + `api/portal/user/changeStatus` , data);
        this.reload();
      }else if(status===2){
        await this.$confirm('禁用该用户吗?', '禁用用户', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'});
        let res = await this.$ajax.post(this.bUrl + `api/portal/user/changeStatus` , data);
        this.reload();
      }
    },
    editUser(item) {
      //  console.log(item);
      this.mode = 'edit';
      this.currentItem = {...item};
      console.log(item,"edititem")
      if (item.role_id) {
        this.currentItem.checkList = item.role_id.split(',');
        this.checkList = this.currentItem.checkList;
      this.currentItem.username = item.username;
      this.currentItem.user_nickname = item.user_nickname;

      this.dialogVisible = true;
     }
    },

    async delUser(id) {
     await this.$confirm('确定删除该用户吗?', '删除用户', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'});
     let res = await this.$ajax.get(this.bUrl + `/api/portal/user/delUser?id=` + id);
     this.reload();
    }
  },
	watch:{
		checkList(val){
			this.currentItem.checkList = val
		}
	}
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.module_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 18px;
  color: #143367;
  align-items: center;
}

.module_tab_cont {
  margin-top: 25px;
}

.ci_plus {
  font-size: 18px;
}


.operate_outer span {
  cursor: pointer;
}

.table {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/usermanage.vue